import script from "./Advice.vue?vue&type=script&async=true&setup=true&lang=ts"
export * from "./Advice.vue?vue&type=script&async=true&setup=true&lang=ts"

const __exports__ = script;

export default __exports__